var _a, _b, _c, _d;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './TenantsListView.html';
import { SegmentService } from 'modules/application/misc/SegmentService';
import { IScope } from 'angular';
import './tenantListView.scss';
import { TenantService } from 'modules/application/tenant/TenantService';
import { AccountService2 } from 'modules/account/AccountService2';
let TenantsListComponent = class TenantsListComponent {
    static $inject = ['$scope', 'SegmentService', 'TenantService', 'PORTALDOMAIN', 'DEFAULT_PORTAL_URL', 'AccountService2', 'USER_AVATAR_DEFAULT_IMAGE'];
    constructor($scope, SegmentService, TenantService, PORTALDOMAIN, DEFAULT_PORTAL_URL, AccountService2, USER_AVATAR_DEFAULT_IMAGE) {
        'ngInject';
        this.$scope = $scope;
        this.SegmentService = SegmentService;
        this.TenantService = TenantService;
        this.PORTALDOMAIN = PORTALDOMAIN;
        this.DEFAULT_PORTAL_URL = DEFAULT_PORTAL_URL;
        this.AccountService2 = AccountService2;
        this.USER_AVATAR_DEFAULT_IMAGE = USER_AVATAR_DEFAULT_IMAGE;
        this.expanded = false;
    }
    /**
     * Getter used on view template
     */
    get portalDomain() {
        return this.PORTALDOMAIN;
    }
    $onInit() {
        this.$scope.$watch(() => this.expanded, () => {
            if (!this.tenants) {
                this.tenantsToShow = [];
            }
            if (this.expanded) {
                this.tenantsToShow = this.tenants;
            }
            else {
                this.tenantsToShow = this.tenants.slice(0, 3);
            }
        });
    }
    async getTenantShow(tenant) {
        tenant.accountType = await this.TenantService.getTenantPlan(tenant.id);
        tenant.url = await this.TenantService.getTenantUrl(tenant.id, false);
    }
    getTenantUrl(tenantId, withProtocol = true) {
        if (tenantId) {
            return this.TenantService.getTenantUrl(tenantId, withProtocol);
        }
        else {
            return this.TenantService.getDefaultPortalUrl(withProtocol);
        }
    }
    showTenants($event) {
        $event.stopPropagation();
    }
    async onTenantClick(tenant) {
        const tenantUrl = this.TenantService.getTenantUrl(tenant.id);
        await this.SegmentService.createTrack('organization-choice', {
            organizationName: tenant.name,
            organizationUrl: tenantUrl,
            status: 'success',
        });
    }
};
TenantsListComponent.$inject = ['$scope', 'SegmentService', 'TenantService', 'PORTALDOMAIN', 'DEFAULT_PORTAL_URL', 'AccountService2', 'USER_AVATAR_DEFAULT_IMAGE'];
TenantsListComponent = __decorate([
    Component({
        template,
        bindings: {
            tenants: '<',
            expanded: '=',
            user: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof IScope !== "undefined" && IScope) === "function" ? _a : Object, typeof (_b = typeof SegmentService !== "undefined" && SegmentService) === "function" ? _b : Object, typeof (_c = typeof TenantService !== "undefined" && TenantService) === "function" ? _c : Object, String, String, typeof (_d = typeof AccountService2 !== "undefined" && AccountService2) === "function" ? _d : Object, String])
], TenantsListComponent);
export { TenantsListComponent };
